
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography, TextField } from "@mui/material";


function Email({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  const [ value, setValue ] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    let inputValid = false;

    const invalidEmailCharsRegex = /[^a-zA-Z0-9@._%+-]/;
    inputValid = invalidEmailCharsRegex.test(inputValue) ? false : true;

    if (inputValid) {
      setValue(inputValue);
      setFormState({
        ...formState,
        [e.target.name]: inputValue,
      });
      setFormError(null);
    };
  };

  return (
    <>
      <Typography
        id='emailLabel'
        component='label'
        htmlFor='emailInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='emailInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='email'
        onChange={onChange}
        value={value}
      />
    </>
  );
};

const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

Email.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { Email, validateEmail };